import React from 'react'

import { TextField ,Grid, Typography} from "@mui/material"
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import Select from '@mui/material/Select';
import BooleanFilter from '../../core/form/BooleanFilter';
import { useSelector, useDispatch } from 'react-redux';
import { setWorkerFilterCriteria } from 'store/slice/ManufSlice';

export default function WorkerFilterCriteria() {
    const dispatch = useDispatch();
    const {filterCriteria} = useSelector((state)=>state.manufslice.workerDashboard);
        
    const {skillList} = useSelector((state)=>state.manufslice);    
    const {explevelList} = useSelector((state)=>state.manufslice);
    
const updateTitleCriteria = (title) =>{
        dispatch(setWorkerFilterCriteria(
            {
                ...filterCriteria,
                title:title
        }))
    }
const updateSkillnameCriteria = (skillname) =>{
        dispatch(setWorkerFilterCriteria(
            {
                ...filterCriteria,
                skillname:skillname
        }))
    }

    return (

        <Grid container direction="row" lg={12} sx={{justifyContent:'center'}}>
                    <Grid item lg={4} padding={1}>
                        <TextField type="search" variant="standard"
                            label="Title"
                            name="title"
                            value={filterCriteria.title}
                            onChange={(e)=>updateTitleCriteria(e.target.value)}
                            sx={{minWidth:'100px'}}
                        />
                    </Grid>

                    <Grid item lg={4} padding={1}>
                        <TextField type="search" variant="standard"
                            label="Skillname"
                            name="skillname"
                            value={filterCriteria.skillname}
                            onChange={(e)=>updateSkillnameCriteria(e.target.value)}
                            sx={{minWidth:'100px'}}
                        />
                    </Grid>


        </Grid>
    )

}